import React from 'react'

import PropTypes from 'prop-types'

import './MagicWand.scss'

const MagicWand = ({ className = '', active = false, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 598.95 597.79"
    className={`magic-wand-icon ${className} ${active ? 'active' : ''}`}
    style={{ transition: 'transform 0.3s', ...props.style }}
    {...props}
  >
    {/* Logo Group */}
    <g className={`logo-group ${active ? 'fade-out' : ''}`}>
      <g transform="translate(-11666.12)">
        {/* Teal Path Container */}
        <g className="logo-teal-container" style={{ transformOrigin: 'center', transformBox: 'fill-box' }}>
          <path
            d="m 0,0 h 163.517 c 3.83,0 7.164,1.397 9.868,4.1 l 163.652,163.651 c 27.891,27.936 27.891,73.579 0,101.515 L 235.475,370.827 c 27.936,-27.936 27.936,-73.625 0,-101.561 L -9.913,23.881 C -18.744,15.049 -12.481,0 0,0"
            style={{ fill: '#00a99d', fillRule: 'evenodd', stroke: 'none' }}
            transform="matrix(1.3333333,0,0,-1.3333333,11734.947,590.5784)"
          />
        </g>
        {/* Blue Path Container */}
        <g className="logo-blue-container" style={{ transformOrigin: 'center', transformBox: 'fill-box' }}>
          <path
            d="m 0,0 h 163.517 c 3.83,0 7.164,-1.397 9.868,-4.1 l 163.652,-163.651 c 27.891,-27.936 27.891,-73.579 0,-101.515 L 235.475,-370.827 c 27.936,27.936 27.936,73.625 0,101.515 L -9.913,-23.881 C -18.744,-15.049 -12.481,0 0,0"
            style={{ fill: '#17155b', fillRule: 'evenodd', stroke: 'none' }}
            transform="matrix(1.3333333,0,0,-1.3333333,11736.981,4.9758667)"
          />
        </g>
      </g>
    </g>

    {/* Wand Group (Scaled to fit ~600px viewBox) */}
    {/* 24px box scaled by ~25 = 600px. Centering adjustment needed. */}
    <g className={`wand-group ${active ? 'fade-in' : ''}`} transform="scale(25) translate(1, 1)">
      {/* Wand Body */}
      <g className="wand-body" style={{ transformOrigin: '10px 14px' }}>
        <path
          d="M3.293 20.707a1 1 0 0 0 1.414 0l10-10a1 1 0 0 0-1.414-1.414l-10 10a1 1 0 0 0 0 1.414z" // Thick handle
          fill="#00a99d"
        />
        <path
          d="M13 11 L19 5" // Connecting line
          stroke="none"
          fill="none"
        />
      </g>

      {/* Sparkles (Blue #17155b) */}
      <g className="sparkles" style={{ fill: '#17155b' }}>
        <path className="sparkle-1" d="M19 2l1 2 2 1-2 1-1 2-1-2-2-1 2-1 1-2z" />
        <path className="sparkle-2" d="M21 11l.5 1 1 .5-1 .5-.5 1-.5-1-1-.5 1-.5.5-1z" />
        <path className="sparkle-3" d="M12 4l.5 1 1 .5-1 .5-.5 1-.5-1-1-.5 1-.5.5-1z" />
      </g>
    </g>
  </svg>
)

MagicWand.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
}

export default MagicWand
